<template>
  <focus-page :title="$t('general.permissionDenied.title')" :message="$t('general.permissionDenied.message')">
    <wo-region>
      <wo-layout>
        <p>
          <po-route-link :value="dashboardRoute" v-t="'general.permissionDenied.action.return'" />
        </p>
      </wo-layout>
    </wo-region>
  </focus-page>
</template>

<script>

import { DASHBOARD } from '@/routes/general'
import FocusPage from '@/components/layout/FocusPage'

export default {
  name: 'PermissionDeniedView',
  components: { FocusPage },
  computed: {
    dashboardRoute () {
      return DASHBOARD
    }
  }
}
</script>
